export const monacoRuleTemplate = `rules:
- rule: untitled
  steps:
  - `
